import { render, staticRenderFns } from "./szkzt.vue?vue&type=template&id=2697d16d&scoped=true&"
import script from "./szkzt.vue?vue&type=script&lang=js&"
export * from "./szkzt.vue?vue&type=script&lang=js&"
import style0 from "./szkzt.vue?vue&type=style&index=0&id=2697d16d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2697d16d",
  null
  
)

export default component.exports